var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-attribute"},[_c('small',{staticClass:"is-block has-text-grey"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"is-block"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }